export const SPLITTERS = {
  BUSINESS: 'This business',
  LENDER_CLIENT: 'The lender/client',
  GROUP_OFFICE: 'Group office',
};
